<script setup>
import { computed } from "vue";
import ResultsStyledBlock from "../ResultsStyledBlock.vue";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";
import CardWidthToggle from "./CardWidthToggle.vue";
import { languageDirection } from "@/utils/textDirection";

const props = defineProps({
  card: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
});

const store = useResultsV2Store();
const textDirection = computed(() => languageDirection(store.displayLanguage));

const text = computed(() => props.card.content?.text || "");
const style = computed(() => props.card.content?.style || "none");
</script>

<template>
  <div :dir="textDirection" class="group relative">
    <!-- Text blocks have no header row, so the toggle floats over the top-right corner -->
    <div
      class="absolute right-2 top-2 z-[1] opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100">
      <CardWidthToggle :card="card" :readonly="readonly" />
    </div>
    <ResultsStyledBlock v-if="text" :html="text" :variant="style" />
    <div v-else class="p-4 text-13 text-muted-foreground">Empty text block</div>
  </div>
</template>
